import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from 'src/app/common/components/spinner-load/spinner.service';
import { DocumentoAddFormAbstractComponent } from 'src/app/common/form/documento/documento-add-form-abstract.component';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'app-add-folder-form',
  templateUrl: './add-folder-form.component.html',
  styleUrls: ['./add-folder-form.component.css']
})
export class AddFolderFormComponent implements OnInit {

  @Input()
  tipiDocumento: TipoDocumento[];

  @Input()
  tipiProvenienza: Provenienza[];

  @Output()
  onReturnCallback = new EventEmitter<DocumentoAllegato>();
  newFolderForm: FormGroup;
  formRequest: DocumentoAllegato = new DocumentoAllegato();
  public editNameDir: boolean;
  documento: DocumentoAllegato = null;
  separatorePathLogico: string = '/';
  isFolder: boolean = false;


  constructor(private campiForm: FormBuilder) {
  }

  ngOnInit() {
    this.isFolder = true
    this.createForm()
  }


  createForm() {
    /* this.tipoAtto = null;
    this.provenienzaAtto = null;
    this.disableSubmit = true; */
    this.formRequest = new DocumentoAllegato();
    this.formRequest.titolo = null;
    this.formRequest.tipoDocumento = null;
    this.formRequest.dataRiferimento = new Date().getTime();
    this.formRequest.provenienza = null;

    // this.fileUploadList = new Array<DocumentoAllegato>();
    if (this.isFolder) {
      this.editNameDir = false; // new name directory
      if (this.documento) {
        this.editNameDir = true; // edit name directory
        this.formRequest.nomeFile = this.documento.nomeFile.split(this.separatorePathLogico).slice(-1)[0];
      }
      this.newFolderForm = this.campiForm.group({
        nomeFile: [this.formRequest.nomeFile, Validators.required]
      });
    }
  }

  saveDir() {
    const obj = new DocumentoAllegato();
    obj.nomeFile = this.formRequest.nomeFile;
    obj.titolo = this.formRequest.nomeFile;
    obj.dataRiferimento = new Date().getTime();
    obj.tipoDocumento = this.tipiDocumento.find(el => el.label === 'VARIE');
    obj.provenienza = this.tipiProvenienza.find(el => el.label === 'INTERNO');
    this.saveDirName(obj, this.editNameDir);
  }


  saveDirName(request: DocumentoAllegato, editNameDir: boolean) {
    this.onReturnCallback.emit(request);
    /* const nomeFile = this.itemSelected.root ? request.nomeFile : this.itemSelected.path + this.separatorePathLogico + request.nomeFile;
    request = {
      ...request,
      nomeFile
    };
    if (editNameDir) { // modifica nome dir
      const requestDir = {
        ...this.documento,
        nomeFile,
        titolo: nomeFile
      };
      // requestDir.dataInput = new DataInput(this.fascicolo.praticaBase.id, this.fascicolo.id, this.fascicolo.praticaBase.intestazione.campi.posizionePratica, this.fascicolo.posizione, this.tipoPratica);
      this.operationService.updateMetadatiDir(this.urlAddDocToSezione, requestDir, this.sezioneId).subscribe(response => this.docUpdated(response));
      // this.operationService.updateMetadatiDocumento(requestDir).subscribe(response => this.docUpdated(response));
    } else {
      //this.operationService.addDocumentoToSezDocumentiAllegatiOrdinario(this.urlAddDocToSezione, request, this.sezioneId, this.fascicoloId).subscribe(response => this.docAdded(response, request));
    } */
  }

  checkNameFile() {
    if (this.formRequest.nomeFile) {
      return !!this.formRequest.nomeFile.includes(this.separatorePathLogico);
    } else {
      return false;
    }
  }


  docUpdated(response) {
    if (response.returnCode === 'OK') {
      console.log('update metadati ok!!! ;-)');
      this.onReturnCallback.emit(response);
    } else {
      console.log('update metadati ko :"[');
    }
  }

  reset(){
    this.onReturnCallback.emit(undefined);
    this.formRequest = new DocumentoAllegato();
  }

}
